import type { ReactNode } from 'react';

import type { ButtonType, ComponentSize } from '../types';

export type NgButtonBaseProps = {
  text?: string;
  children?: ReactNode;
  cssClass?: string;
  type?: ButtonType;
  outline?: boolean;
  outlineTransparent?: boolean;
  size?: ComponentSize;
  icon?: string;
};

export function isIconOnly(props: NgButtonBaseProps): boolean {
  return props.children == null && props.text == null && props.icon != null;
}

function effectiveSizeType(size: ComponentSize): string {
  switch (size) {
    case 'normal':
      return '';
    case 'small':
      return 'btn-sm';
    case 'large':
      return 'btn-lg';
  }
}

export function displayCssClass(props: NgButtonBaseProps): string {
  return isIconOnly(props)
    ? 'd-inline icon-only'
    : 'd-inline-flex gap-2 align-items-center justify-content-center';
}

export function effectiveBaseCssClass(props: NgButtonBaseProps): string {
  const type = props.type ?? 'primary';
  const outline = props.outline ?? false;
  const effectiveColorType = `${outline ? 'outline-' : ''}${type}`;
  const effectiveOutlineWhiteBackground =
    outline && !props.outlineTransparent ? 'btn-outline-bg-white' : '';
  const buttonBootstrapCssStyle = `btn btn-${effectiveColorType} ${effectiveOutlineWhiteBackground} ${effectiveSizeType(props.size ?? 'normal')}`;
  return `${buttonBootstrapCssStyle} ${props.cssClass ?? ''}`;
}
